import { render, staticRenderFns } from "./openingBalance.vue?vue&type=template&id=53aafd22&scoped=true&"
import script from "./openingBalance.vue?vue&type=script&lang=js&"
export * from "./openingBalance.vue?vue&type=script&lang=js&"
import style0 from "./openingBalance.vue?vue&type=style&index=0&id=53aafd22&lang=scss&scoped=true&"
import style1 from "./openingBalance.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./openingBalance.vue?vue&type=style&index=2&id=53aafd22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aafd22",
  null
  
)

export default component.exports